export enum TransferStatus {
  Pending = 0,
  Approved,
  Rejected,
  'In Progress',
  Failed,
  Refunded
}